export class UserRole {
    public RoleId: number;
    public UserGroupId: number;
    public Name: string;
    public Description: string;
    public IsActive: boolean;
    public DisplayName: string;
}